import type { components } from "@/api-schema";
import type { AddressFormValues } from "../address-form-schema";

type AddressDto = components["schemas"]["AddressDto"];

export function addressFormValuesToAddressDto(address: AddressFormValues): AddressDto {
  const longitudeRaw = address.longitude;
  const latitudeRaw = address.latitude;

  const longitude =
    longitudeRaw === undefined || longitudeRaw === null || longitudeRaw === ""
      ? undefined
      : (() => {
          const value = Number(longitudeRaw);
          return Number.isFinite(value) ? value : undefined;
        })();
  const latitude =
    latitudeRaw === undefined || latitudeRaw === null || latitudeRaw === ""
      ? undefined
      : (() => {
          const value = Number(latitudeRaw);
          return Number.isFinite(value) ? value : undefined;
        })();

  return {
    ...address,
    longitude,
    latitude,
  };
}
